import makeStyles from '@mui/styles/makeStyles';
import { Box, Grid, Theme, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import { useRecoilValue } from 'recoil';
import React from 'react';
import {
  GenericPayRateOverviewProps,
  HotStreakParameter,
} from '../../../interfaces/PayRate';
import { sharedColors, useSharedStyles } from '../../../utilities/Styles';
import { locations as locationsAtom } from '../../../atoms/Location';
import {
  filterLocationById,
  getTimeZoneByLocationId,
} from '../../../utilities/Locations';
import { multiClass } from '../../../utilities/Extensions';
import { formatDateTime } from '../../../utilities/Dates';

export const HotStreakParameterOverview = (
  props: GenericPayRateOverviewProps,
) => {
  const classes = useStyles();
  const sharedClasses = useSharedStyles().classes;

  const locations = useRecoilValue(locationsAtom);

  const hotStreakParameter = props.payRate as HotStreakParameter;

  const locationId = parseInt(hotStreakParameter.locationID, 10);
  const location = filterLocationById(locations, locationId);
  const timeZone =
    getTimeZoneByLocationId(
      locations,
      parseInt(hotStreakParameter.locationID, 10),
    ) || 'UTC';

  return (
    <Grid container spacing={1} className={classes.grid}>
      <Grid key='locationId' item xs={12}>
        <Box component='div' className={classes.fieldWrapper}>
          <Typography
            className={multiClass([sharedClasses.overline, classes.fieldName])}
            component={'div'}
          >
            Location Name
          </Typography>
          <Typography className={sharedClasses.body1} component={'div'}>
            {location?.name || '-'}
          </Typography>
        </Box>
      </Grid>
      <Grid key='startDate' item xs={12}>
        <Box component='div' className={classes.fieldWrapper}>
          <Typography
            component={'div'}
            className={multiClass([sharedClasses.overline, classes.fieldName])}
          >
            Start At
          </Typography>
          <Typography component='div' className={sharedClasses.body1}>
            {formatDateTime(hotStreakParameter.startAt, timeZone)}
          </Typography>
        </Box>
      </Grid>
      <Grid key='lower-limit' item xs={12}>
        <Box component='div' className={classes.fieldWrapper}>
          <Typography
            component={'div'}
            className={multiClass([sharedClasses.overline, classes.fieldName])}
          >
            Prioritization Threshold
          </Typography>
          <Typography
            component={'div'}
            className={multiClass([
              sharedClasses.body1,
              classes.fieldValueWithUnit,
            ])}
          >
            {hotStreakParameter.prioritizationThreshold ?? '-'}
          </Typography>
        </Box>
      </Grid>
      <Grid key='upper-limit' item xs={12}>
        <Box component='div' className={classes.fieldWrapper}>
          <Typography
            component={'div'}
            className={multiClass([sharedClasses.overline, classes.fieldName])}
          >
            Time Based Fairness Threshold (Minutes)
          </Typography>
          <Typography
            component={'div'}
            className={multiClass([
              sharedClasses.body1,
              classes.fieldValueWithUnit,
            ])}
          >
            {hotStreakParameter.timeBasedFairnessThresholdInMinutes ?? '-'}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fieldWrapper: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
    fieldName: {
      color: sharedColors.gray4,
      textTransform: 'uppercase',
      marginBottom: theme.spacing(0.2),
    },
    fieldValueWithUnit: {
      display: 'flex',
      flexDirection: 'row',
    },
    fieldUnit: {
      color: sharedColors.gray5,
      marginTop: 'auto',
      marginBottom: 'auto',
      marginLeft: theme.spacing(0.2),
    },
    grid: {
      flexGrow: 1,
    },
  }),
);
